import React, {useState, useEffect} from 'react';
import withRouter from '../Common/withRouter';
//Import Icons
import Icon from '@ailibs/feather-react-ts';
import classname from 'classnames';
import PropTypes from 'prop-types';
//i18n
import {withTranslation} from 'react-i18next';
//redux
import {useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import {Row, Col, Collapse} from 'reactstrap';
import {selectLayoutState} from 'store/layout/selectors';

const Navbar = (props: any) => {
  const {leftMenu} = useSelector(selectLayoutState);

  const [ui, setui] = useState<boolean>(false);
  const [app, setapp] = useState<boolean>(false);
  const [email, setemail] = useState<boolean>(false);
  const [contact, setcontact] = useState<boolean>(false);
  const [component, setcomponent] = useState<boolean>(false);
  const [form, setform] = useState<boolean>(false);
  const [table, settable] = useState<boolean>(false);
  const [chart, setchart] = useState<boolean>(false);
  const [icon, seticon] = useState<boolean>(false);
  const [map, setmap] = useState<boolean>(false);
  const [extra, setextra] = useState<boolean>(false);
  const [invoice, setinvoice] = useState<boolean>(false);
  const [auth, setauth] = useState<boolean>(false);
  const [utility, setutility] = useState<boolean>(false);

  useEffect(() => {
    var matchingMenuItem = null;
    var ul: any = document.getElementById('navigation');
    var items: any = ul.getElementsByTagName('a');
    for (var i = 0; i < items.length; ++i) {
      if (window.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  });
  function activateParentDropdown(item: any) {
    item.classList.add('active');
    const parent = item.parentElement;
    if (parent) {
      parent.classList.add('active'); // li
      const parent2 = parent.parentElement;
      parent2.classList.add('active'); // li
      const parent3 = parent2.parentElement;
      if (parent3) {
        parent3.classList.add('active'); // li
        const parent4 = parent3.parentElement;
        if (parent4) {
          parent4.classList.add('active'); // li
          const parent5 = parent4.parentElement;
          if (parent5) {
            parent5.classList.add('active'); // li
            const parent6 = parent5.parentElement;
            if (parent6) {
              parent6.classList.add('active'); // li
            }
          }
        }
      }
    }
    return false;
  }

  return (
    <React.Fragment>
      <div className="topnav">
        <div className="container-fluid">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav">
                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle arrow-none"
                    to="/dashboard"
                  >
                    <Icon name="home" />
                    <span>{'Dashboard'}</span>
                  </Link>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    to="/#"
                    onClick={e => {
                      e.preventDefault();
                      setui(!ui);
                    }}
                    className="nav-link dropdown-toggle arrow-none"
                  >
                    <Icon name="briefcase" />
                    {'Elements'} <div className="arrow-down"></div>
                  </Link>
                  <div
                    className={classname(
                      'dropdown-menu mega-dropdown-menu dropdown-menu-left dropdown-mega-menu-xl',
                      {show: ui}
                    )}
                  >
                    <div className="ps-2 p-lg-0">
                      <Row>
                        <Col lg={8}>
                          <div>
                            <div className="menu-title">{'Elements'}</div>
                            <Row>
                              <Col lg={5}>
                                <div>
                                  <Link
                                    to="/ui-alerts"
                                    className="dropdown-item"
                                  >
                                    {'Alerts'}
                                  </Link>
                                  <Link
                                    to="/ui-buttons"
                                    className="dropdown-item"
                                  >
                                    {'Buttons'}
                                  </Link>
                                  <Link
                                    to="/ui-cards"
                                    className="dropdown-item"
                                  >
                                    {'Cards'}
                                  </Link>
                                  <Link
                                    to="/ui-carousel"
                                    className="dropdown-item"
                                  >
                                    {'Carousel'}
                                  </Link>
                                  <Link
                                    to="/ui-dropdowns"
                                    className="dropdown-item"
                                  >
                                    {'Dropdowns'}
                                  </Link>
                                  <Link to="/ui-grid" className="dropdown-item">
                                    {'Grid'}
                                  </Link>
                                  <Link
                                    to="/ui-images"
                                    className="dropdown-item"
                                  >
                                    {'Images'}
                                  </Link>
                                  <Link
                                    to="/ui-modals"
                                    className="dropdown-item"
                                  >
                                    {'Modals'}
                                  </Link>
                                  <Link
                                    to="/ui-offcanvas"
                                    className="dropdown-item"
                                  >
                                    {'Offcanvas'}
                                  </Link>
                                </div>
                              </Col>
                              <Col lg={5}>
                                <div>
                                  <Link
                                    to="/ui-progressbars"
                                    className="dropdown-item"
                                  >
                                    {'Progress Bars'}
                                  </Link>
                                  <Link
                                    to="/ui-placeholders"
                                    className="dropdown-item"
                                  >
                                    {'Placeholders'}
                                  </Link>
                                  <Link
                                    to="/ui-tabs-accordions"
                                    className="dropdown-item"
                                  >
                                    {'Tabs & Accordions'}
                                  </Link>
                                  <Link
                                    to="/ui-typography"
                                    className="dropdown-item"
                                  >
                                    {'Typography'}
                                  </Link>
                                  <Link
                                    to="/ui-toasts"
                                    className="dropdown-item"
                                  >
                                    {'Toasts'}
                                  </Link>
                                  <Link
                                    to="/ui-video"
                                    className="dropdown-item"
                                  >
                                    {'Video'}
                                  </Link>
                                  <Link
                                    to="/ui-general"
                                    className="dropdown-item"
                                  >
                                    {'General'}
                                  </Link>
                                  <Link
                                    to="/ui-colors"
                                    className="dropdown-item"
                                  >
                                    {'Colors'}
                                  </Link>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                        <Col lg={4}>
                          <div>
                            <div className="menu-title">{'Extended'}</div>
                            <Link
                              to="/extended-lightbox"
                              className="dropdown-item"
                            >
                              {'Lightbox'}
                            </Link>
                            <Link
                              to="/extended-rangeslider"
                              className="dropdown-item"
                            >
                              {'Range Slider'}
                            </Link>
                            <Link
                              to="/extended-session-timeout"
                              className="dropdown-item"
                            >
                              {'Session Timeout'}
                            </Link>
                            <Link
                              to="/extended-rating"
                              className="dropdown-item"
                            >
                              {'Rating'}
                            </Link>
                            <Link
                              to="/extended-notifications"
                              className="dropdown-item"
                            >
                              {'Notifications'}
                            </Link>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    to="/#"
                    onClick={e => {
                      e.preventDefault();
                      setapp(!app);
                    }}
                    className="nav-link dropdown-togglez arrow-none"
                  >
                    <Icon name="grid" />
                    {'Apps'} <div className="arrow-down"></div>
                  </Link>
                  <div className={classname('dropdown-menu', {show: app})}>
                    <Link to="/apps-calendar" className="dropdown-item">
                      {'Calendar'}
                    </Link>
                    <Link to="/apps-chat" className="dropdown-item">
                      {'Chat'}
                    </Link>
                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault();
                          setemail(!email);
                        }}
                      >
                        {'Email'} <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname('dropdown-menu', {show: email})}
                      >
                        <Link to="/email-inbox" className="dropdown-item">
                          {'Inbox'}
                        </Link>
                        <Link to="/email-read" className="dropdown-item">
                          {'Read Email'}
                        </Link>
                      </div>
                    </div>
                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault();
                          setinvoice(!invoice);
                        }}
                      >
                        {'Invoices'} <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname('dropdown-menu', {
                          show: invoice,
                        })}
                      >
                        <Link to="/invoices-list" className="dropdown-item">
                          {'Invoice List'}
                        </Link>
                        <Link to="/invoices-detail" className="dropdown-item">
                          {'Invoice Detail'}
                        </Link>
                      </div>
                    </div>

                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault();
                          setcontact(!contact);
                        }}
                      >
                        {'Contacts'} <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname('dropdown-menu', {
                          show: contact,
                        })}
                      >
                        <Link to="/contacts-grid" className="dropdown-item">
                          {'User Grid'}
                        </Link>
                        <Link to="/contacts-list" className="dropdown-item">
                          {'User List'}
                        </Link>
                        <Link to="/contacts-profile" className="dropdown-item">
                          {'Profile'}
                        </Link>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    to="/#"
                    className="nav-link dropdown-toggle arrow-none"
                    onClick={e => {
                      e.preventDefault();
                      setcomponent(!component);
                    }}
                  >
                    <Icon name="box" />
                    {'Components'} <div className="arrow-down"></div>
                  </Link>
                  <div
                    className={classname('dropdown-menu', {show: component})}
                  >
                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault();
                          setform(!form);
                        }}
                      >
                        {'Forms'} <div className="arrow-down"></div>
                      </Link>
                      <div className={classname('dropdown-menu', {show: form})}>
                        <Link to="/form-elements" className="dropdown-item">
                          {'Basic Elements'}
                        </Link>
                        <Link to="/form-validation" className="dropdown-item">
                          {'Validation'}
                        </Link>
                        <Link to="/form-advanced" className="dropdown-item">
                          {'Advanced Plugins'}
                        </Link>
                        <Link to="/form-editors" className="dropdown-item">
                          {'Editors'}
                        </Link>
                        <Link to="/form-uploads" className="dropdown-item">
                          {'File Upload'}{' '}
                        </Link>
                        <Link to="/form-wizard" className="dropdown-item">
                          {'Wizard'}
                        </Link>
                        <Link to="/form-mask" className="dropdown-item">
                          {'Form Mask'}
                        </Link>
                      </div>
                    </div>
                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault();
                          settable(!table);
                        }}
                      >
                        {'Tables'} <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname('dropdown-menu', {show: table})}
                      >
                        <Link to="/tables-basic" className="dropdown-item">
                          {'Bootstrap Basic'}
                        </Link>
                        <Link to="/tables-datatable" className="dropdown-item">
                          {'Data Tables'}
                        </Link>
                        <Link to="/tables-responsive" className="dropdown-item">
                          {'Responsive'}
                        </Link>
                        <Link to="/tables-editable" className="dropdown-item">
                          {'Editable'}
                        </Link>
                      </div>
                    </div>
                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault();
                          setchart(!chart);
                        }}
                      >
                        {'Charts'} <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname('dropdown-menu', {show: chart})}
                      >
                        <Link to="/charts-apex" className="dropdown-item">
                          {' '}
                          {'Apex charts'}
                        </Link>
                        <Link to="/charts-echart" className="dropdown-item">
                          {' '}
                          {'E Charts'}
                        </Link>
                        <Link to="/charts-chartjs" className="dropdown-item">
                          {' '}
                          {'Chartjs'}
                        </Link>
                        <Link to="/charts-sparkline" className="dropdown-item">
                          {'Sparkline'}
                        </Link>
                      </div>
                    </div>
                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault();
                          seticon(!icon);
                        }}
                      >
                        {'Icons'} <div className="arrow-down"></div>
                      </Link>
                      <div className={classname('dropdown-menu', {show: icon})}>
                        <Link to="/icons-boxicons" className="dropdown-item">
                          {'Boxicons'}
                        </Link>
                        <Link
                          to="/icons-materialdesign"
                          className="dropdown-item"
                        >
                          {'Material Design'}
                        </Link>
                        <Link to="/icons-dripicons" className="dropdown-item">
                          {'Dripicons'}
                        </Link>
                        <Link to="/icons-fontawesome" className="dropdown-item">
                          {'Font awesome'}{' '}
                        </Link>
                      </div>
                    </div>
                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault();
                          setmap(!map);
                        }}
                      >
                        {'Maps'} <div className="arrow-down"></div>
                      </Link>
                      <div className={classname('dropdown-menu', {show: map})}>
                        <Link to="/maps-google" className="dropdown-item">
                          {'Google'}{' '}
                        </Link>
                        <Link to="/maps-vector" className="dropdown-item">
                          {'Vector'}{' '}
                        </Link>
                        <Link to="/maps-leaflet" className="dropdown-item">
                          {'Leaflet'}{' '}
                        </Link>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle arrow-none"
                    to="/#"
                    onClick={e => {
                      e.preventDefault();
                      setextra(!extra);
                    }}
                  >
                    <Icon name="file-text" />
                    {'Extra pages'} <div className="arrow-down"></div>
                  </Link>
                  <div className={classname('dropdown-menu', {show: extra})}>
                    <div className="dropdown">
                      <Link
                        to="/#"
                        className="dropdown-item dropdown-toggle arrow-none"
                        onClick={e => {
                          e.preventDefault();
                          setauth(!auth);
                        }}
                      >
                        {'Authentication'} <div className="arrow-down"></div>
                      </Link>
                      <div className={classname('dropdown-menu', {show: auth})}>
                        <Link to="/page-login" className="dropdown-item">
                          {'Login'}
                        </Link>
                        <Link to="/page-register" className="dropdown-item">
                          {'Register'}
                        </Link>
                        <Link to="/page-recoverpw" className="dropdown-item">
                          {'Recover Password'}
                        </Link>
                        <Link to="/page-lock-screen" className="dropdown-item">
                          {'Lock Screen'}
                        </Link>
                        <Link to="/page-confirm-mail" className="dropdown-item">
                          {'Confirm Mail'}
                        </Link>
                        <Link
                          to="/page-email-verification"
                          className="dropdown-item"
                        >
                          {'Email Verification'}
                        </Link>
                        <Link
                          to="/page-two-step-verification"
                          className="dropdown-item"
                        >
                          {'Two Step Verification'}
                        </Link>
                      </div>
                    </div>

                    <div className="dropdown">
                      <Link
                        className="dropdown-item dropdown-toggle arrow-none"
                        to="/#"
                        onClick={e => {
                          e.preventDefault();
                          setutility(!utility);
                        }}
                      >
                        {'Utility'} <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname('dropdown-menu', {
                          show: utility,
                        })}
                      >
                        <Link to="/pages-starter" className="dropdown-item">
                          {'Starter Page'}
                        </Link>
                        <Link to="/pages-maintenance" className="dropdown-item">
                          {'Maintenance'}
                        </Link>
                        <Link to="/pages-comingsoon" className="dropdown-item">
                          {'Coming Soon'}
                        </Link>
                        <Link to="/pages-timeline" className="dropdown-item">
                          {'Timeline'}
                        </Link>
                        <Link to="/pages-faqs" className="dropdown-item">
                          {'FAQs'}
                        </Link>
                        <Link to="/pages-pricing" className="dropdown-item">
                          {'Pricing'}
                        </Link>
                        <Link to="/pages-404" className="dropdown-item">
                          {'Error 404'}
                        </Link>
                        <Link to="/pages-500" className="dropdown-item">
                          {'Error 500'}
                        </Link>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  );
};

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
};

export default withTranslation()(withRouter(Navbar));
